<template>
	<div class="home">
        <!-- 模块列表 -->
        <div class="home-content">
            <template v-for="(item, index) in xitoList">
            	<div 
            		:id="item.id"
            		:key="item.id"
            		:type="item.type"
            		:index="index"
            		:typeData="item"
                    :themeColor="themeColor"
            		:is="componentConfig[item.type]" 
            		v-if="componentConfig[item.type]"
            		:class="item.type | setModuleClass">
            	</div>
            </template>
        </div>
        <!-- 返回顶部 -->
        <span class="go-back-top">Top</span>
    </div>
</template>

<script>
    // 模块组件列表
	import socket from 'util/socket.js'
	import component from './module/index.js'
	import iframeConnect from 'util/iframeConnect.js'
    import phamulaHandler from 'util/phamulaHandler.js'
    import { timeout, throttle } from 'util/timeout.js'
    import { judgeData, getPhamulaJson, filterPhamulaJson } from 'util/getPhamula.js'
	import scrollReveal from 'scrollreveal'
	import X2Js from 'x2js'
	const x2js = new X2Js();
	// import phamula_analysis from 'util/phamula_analysis.js'
    // phamula_analysis('1520').then(res => console.log(JSON.parse(JSON.stringify(res))))
	export default {
		name: 'home',
		data() {
			return {
                editMode: false,
                xitoList: [],
                blockList: [],
				themeColor: '#41466E',
                scrollSocket: null,
				scrollReveal: scrollReveal()
            }
		},
		watch: {
            // '$route': {
            //     async handler(newValue) {
            //         await this.$config.extendConfig();
            //         this.closeScrollSocket();
            //         this.blockList = [];
            //         this.xitoList = [];
            //         this.getData();
            //     },
            //     immediate: true,
            //     deep: true
            // }
            '$route'(newValue) {
                window.location.reload();
            }
		},
		created() {
			// https://pageview.xitohere.com/#/
			console.log(this.$config)
			this.closeScrollSocket();
		},
        mounted() {
			// console.clear()
			// console.clear()
			// console.clear()
			if (this.isIframe) {
            	console.log('%c 子页面初始化完成', 'color: green')
				if (document.body.classList.contains('iframe-body') === false) {
					document.body.classList.add('iframe-body');
				}
				const config = {
					role: 'child',
					debug: true,
					target: window,
					whiteList: process.env.NODE_ENV === 'development' ? '*' : [
					    'http://localhost:8080',
					    'http://localhost:8081',
					    'http://localhost:8082',
					    'http://localhost:8083',
					    
					    'https://webapp.xitohere.com',
					    'https://lisheng.xitohere.com',
					    'https://contents.expo-museum.com',
					    'https://varyon.xitotech.com'
					]
				};
				const onEvent = this.receiveMessage.bind(this);
				// 建立与父页面通信
				iframeConnect.init(config, onEvent);
				// 编辑模式
				this.editMode = true;
				// 页面加载完毕，发送初始化完成信号
				this.sendMessage('INIT_END');
			} else {
				this.blockList = [];
				this.xitoList = [];
				this.getData();
			}
        },
		methods: {
			sendMessage(type = '', data = null) {
				if (type) {
					// INIT_END 			页面加载完成 => 显示场景
					data ? iframeConnect.sendMessage(type, data) : iframeConnect.sendMessage(type);
				}
			},
            receiveMessage({ type, data }) {
				switch(type) {
                	case 'PAGE_LOADED':
                		// 页面加载完毕，发送初始化完成信号
                        this.sendMessage('INIT_END');
                        // 关闭加载动画
                        this.$loading('', false);
                		break;
                	case 'DATA_UPDATE':
                        // 将接收隐私弹窗每次设置为false
                        this.$userInfo.setData({ accept: false });
                		// 数据更新
                        this.loadDataSuccess(data || [], false);
                		break;
                	case 'SET_LANGUAGE':
                		// 设置多语言
                        // this.$store.commit('modifyLanguage', data);
                		break;
                }
            },
            async getData() {
                // 显示加载动画
                this.$loading('正在加载数据中', true);
                // 如果存在文件路径名称
                if (this.$config['jsonFile']) {
                    // 拉取本地文件
                    const jsonResult = await this.$http.custom.phamula('./' + this.$config['jsonFile']);
                    if (jsonResult.status === 'success' && judgeData(jsonResult.data, 'phamula_tree')) {
                        // 初始化重排显示顺序
                        jsonResult.data.obj_relation_json.jsonStr.su = this.dataReorder(jsonResult.data.obj_relation_json.jsonStr.su || []);
						this.loadDataEnded(jsonResult.data);
						// jsonResult.data = await filterPhamulaJson(jsonResult.data, async (type, data) => {
      //                       if (type === 'error') {
      //                           this.loadDataError();
      //                       }
      //                       if (type === 'start') {}
      //                       if (type === 'end') {
      //                           if (judgeData(data, 'phamula_tree')) {
      //                               // 边加载边显示
      //                               this.displayWhileLoading(data.obj_relation_json.jsonStr.su || []);
      //                               // 初始化加载头部、尾部、客服框、常见问题的phamula数据
      //                               data.obj_relation_json.jsonStr.su = await this.loadPhamula(data.obj_relation_json.jsonStr.su || [], 'filter');
      //                           }
      //                           this.loadDataEnded(data);
      //                           // this.loadDataSuccess(data);
      //                       }
      //                   }, async phamula => {
      //                       if (judgeData(phamula, 'phamula_tree')) {
      //                           // 初始化重排显示顺序
      //                           phamula.obj_relation_json.jsonStr.su = this.dataReorder(phamula.obj_relation_json.jsonStr.su || []);
      //                       }
      //                       return phamula;
      //                   });
                        return;
                    }
                }
                // 如果存在phamula_id
                if (this.$config['libraryId']) {
                    // 拉取数据
                    if (isNaN(this.$config['libraryId']) === false && Number(this.$config['libraryId']) > 0) {
                        getPhamulaJson(this.$config['libraryId'], async (type, data, index, length) => {
                            if (type === 'error') {
                                this.loadDataError();
                            }
                            if (type === 'start') {}
                            if (type === 'update') {
                                if (judgeData(data, 'phamula_tree')) {
                                    // 边加载边显示
                                    this.displayWhileLoading(data.obj_relation_json.jsonStr.su || []);
                                }
                            }
                            if (type === 'end') {
                                if (judgeData(data, 'phamula_tree')) {
                                    // 初始化加载头部、尾部、客服框、常见问题的phamula数据
                                    data.obj_relation_json.jsonStr.su = await this.loadPhamula(data.obj_relation_json.jsonStr.su || [], 'get');
                                }
                                this.loadDataEnded(data);
                                // this.loadDataSuccess(data);
                            }
                        }, async phamula => {
                            if (judgeData(phamula, 'phamula_tree')) {
                                // 初始化重排显示顺序
                                phamula.obj_relation_json.jsonStr.su = this.dataReorder(phamula.obj_relation_json.jsonStr.su || []);
                            }
                            return phamula;
                        });
                        return;
                    }
                }
                this.loadDataError();
                
                // // 拉取xml数据
                // const xmlResult = await this.$http.custom.xml('./xml/index.xml');
                // console.log(xmlResult)
                // if (xmlResult.status === 'success') {
                //     console.log(x2js.xml2js(xmlResult.data))
                // }
            },
            async loadPhamula(jsonList = [], type = 'get') {
                // type => get获取 filter过滤
                // 加载头部、尾部、客服框、常见问题的phamula数据
                for (let i = 0, length = jsonList.length; i < length; i++) {
                    // if (jsonList[i].su && jsonList[i].su.length && ['typeHeader', 'typeFooter', 'typeTalk', 'typeO'].indexOf(jsonList[i].edd) > -1) {
                    if (jsonList[i].su && jsonList[i].su.length && ['typeHeader', 'typeFooter'].indexOf(jsonList[i].edd) > -1) {
                        if (type === 'filter') {
                            if (judgeData(jsonList[i].su[0]._phamula_data, 'phamula_tree')) {
                                let phamulaData = await filterPhamulaJson(jsonList[i].su[0]._phamula_data);
                                // console.log('文件', JSON.parse(JSON.stringify(phamulaData)))
                                if (phamulaData && judgeData(phamulaData, 'phamula_tree')) {
                                    jsonList[i].su[0]._phamula_data = phamulaData;
                                }
                            } else {
                                type = 'get';
                            }
                        }
                        if (type === 'get') {
                            let phamula_id = jsonList[i].su[0]._object_data && jsonList[i].su[0]._object_data.phamula_id;
                            // console.log('ID', phamula_id)
                            if (phamula_id && isNaN(phamula_id) === false && Number(phamula_id) > 0) {
                                let { status, data } = await getPhamulaJson(phamula_id);
                                if (status === 'success' && judgeData(data, 'phamula_tree')) {
                                    jsonList[i].su[0]._phamula_data = data;
                                }
                            }
                        }
                    }
                }
                return jsonList;
            },
            effectInit() {
            	const offset = 300,
            		  scroll_top_duration = 700,
            		  $back_to_top = $('.go-back-top');
            	$(window).scroll(function(){
            		( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible');
            	});
            	// 返回最顶部
            	$back_to_top.on('click', function(event){
            		event.preventDefault();
            		$('body,html').animate({ scrollTop: 0 }, scroll_top_duration);
            	});
            	this.scrollReveal.reveal('.scroll-reveal', {
            		// 动画的时长
            		duration: 1000,
            		// 延迟时间
            		delay: 500,
            		// 动画开始的位置，'bottom', 'left', 'top', 'right'
            		origin: 'bottom',
            		// 回滚的时候是否再次触发动画
            		reset: false,
            		// 在移动端是否使用动画
            		mobile: false,
            		// 滚动的距离，单位可以用%，rem等
            		distance: '300px',
            		// 其他可用的动画效果
            		opacity: 1,
            		easing: 'linear',
            		scale: 1,
            	});
            },
            dataReorder(jsonList = []) {
                // 重排显示顺序
                const sortList = [
                    'typeHeader',   // typeHeader将头部导航栏放至第一
                    'typeJ',        // typeJ将接受隐私条款(弹窗)放至倒数第四
                    'typeQ',        // typeQ将输入口令(弹窗)放至倒数第三
                    'typeTalk',     // typeTalk将客服聊天窗口(弹窗)放至倒数第二
                    'typeFooter'    // typeFooter将尾部导航栏放至末尾
                ];
                for (let type of sortList) {
                    let index = jsonList.findIndex(v => (v.edd || v.type) === type);
                    if (index > -1) {
                        if (type === 'typeHeader') {
                            jsonList.unshift(JSON.parse(JSON.stringify(jsonList[ index ])));
                            jsonList.splice(index + 1, 1);
                        } else {
                            jsonList.push(JSON.parse(JSON.stringify(jsonList[ index ])));
                            jsonList.splice(index, 1);
                        }
                    }
                }
                return jsonList;
            },
            blockPosition() {
            	const div = document.querySelector('.home-content');
                const children = div.querySelectorAll('.scroll-reveal');
            	this.blockList = Array.from(children).map(v => {
            		let index = v.getAttribute('index');
            		let type = v.getAttribute('type');
            		let id = v.getAttribute('id');
            		let result = this.xitoList.find(p => p.id === id);
            		let object_id = result.object_id_list || [];
            		let height = v.offsetHeight;
            		let top = v.offsetTop;
            		return {
            			top,
            			type,
            			height,
            			object_id
            		};
            	})
            },
            loadDataError() {
                this.$loading('', false);
                this.$message('数据错误');
            },
            browserScroll(event) {
                if (this.scrollSocket.getConnected()) {
                    const height = document.querySelector('.home-content').offsetHeight;
                    const top = window.scrollY + Math.floor(window.innerHeight / 2);
                    const length = this.blockList.length;
                    if (length) {
                        let index = length - 1;
                        for (let i = 0; i < length; i++) {
                        	let sTop = this.blockList[i].top;
                        	let eTop = this.blockList[i].top + this.blockList[i].height;
                        	if (sTop <= top && top < eTop) {
                        		index = i;
                        		break;
                        	}
                        }
                        const result = this.blockList[index];
                        let uuid = this.$uuid;
                        let name = result.type;
                        let url = window.location.href;
                        let sorcllTop = window.scrollY;
                        let object_id = result.object_id;
                        let time = this.$time.now.timestamp;
                        let action = '/realtime/webBrowsingCollection';
                        let percen = Math.round(window.scrollY / (height - window.innerHeight) * 10000) / 100 + '%';
                        this.scrollSocket.emit('communication', {
                        	url,
                        	uuid,
                        	time,
                        	name,
                        	index,
                        	action,
                        	percen,
                        	sorcllTop,
                        	object_id
                        });
                    }
                }
            },
            loadDataEnded(phamula = {}) {
                // console.clear()
                // this.$userInfo.setData({ accept: false });
                // console.log('%c环境变量', 'color: red', process.env)
                // console.log('%cuuid', 'color: red', JSON.parse(JSON.stringify(this.$uuid)))
                // console.log('%cconfig', 'color: red', JSON.parse(JSON.stringify(this.$config)))
                // console.log('%cuserInfo', 'color: red', JSON.parse(JSON.stringify(this.$userInfo)))
                // console.log('\n')
                if (this.editMode) {
                    return;
                }
                if (judgeData(phamula, 'phamula_tree') && phamula.obj_relation_json.type == 6) {
                    const jsonList = phamula.obj_relation_json.jsonStr.su || [];
                    this.loadDataSuccess(jsonList, true);
                    this.phamula = phamula;
                } else {
                    this.loadDataError();
                }
            },
            loadDataSuccess(jsonList = [], openScrollSocket = false) {
                // const xitoList = this.dataReorder(phamulaHandler(jsonList));
                const xitoList = this.dataReorder(phamulaHandler(jsonList, 0, true));
                if (xitoList.length) {
                    // 1520          (1135 17373) (1116 16954) (1149 17388) (1019 16748)
                    // xxx           (521 1951)   (427 1652)   (456 1279)   (427 1702)
                    // p_id=xito_old (327 6567)   (236 6621)   (281 6621)   (216 6205)
                    // 显示数据
                    this.xitoList = xitoList;
                    // this.xitoList = xitoList.slice(15, 16);
                    // 开启socket
                    if (openScrollSocket) {
                        this.openScrollSocket();
                    }
                    // 开启特效
                    this.$nextTick(() => {
                    	// 特效在DOM生成之后开启
                    	this.effectInit();
                    	// 获取每个模块的位置
                    	this.blockPosition();
                        // console.clear()
                        // console.log(this.$config)
                        // console.log(JSON.parse(JSON.stringify(phamula)))
                        // console.log('\n')
                        // console.log(JSON.parse(JSON.stringify(jsonList)))
                        // console.log('\n')
                        console.log(JSON.parse(JSON.stringify(xitoList)))
                        // console.log('\n')
                        // console.log(JSON.parse(JSON.stringify(this.blockList)))
                    });
                }
                this.$loading('', false);
            },
            openScrollSocket() {
				if (this.isIframe === false) {
					this.scrollSocket = socket({
						global: this,
						config: {
							debug: false,
					        connection: this.api + '?use_type=webBrowsingCollection'
						},
						events: {
							'error': function(error) {
								console.error(error);
								this.$message(error);
							}
						}
					    /*
						events: {
							// 正在连接
							'connect': function(data) {},
					        // 重新连接
							'reconnect': function(data) {},
					        // 断开连接
							'disconnect': function(data) {},
							// socket连接成功
							'socketConnectioned': function(data) {},
							// 正在连接
							'connect': console.log,
					        // 重新连接
							'reconnect': console.log,
					        // 断开连接
							'disconnect': console.log,
							// socket连接成功
							'socketConnectioned': console.log,
						}
					    */
					});
					window.onscroll = throttle(this.browserScroll, 200);
				}
            },
            closeScrollSocket() {
                if (this.scrollSocket && this.scrollSocket.close) {
                    this.scrollSocket.close();
                }
            },
            displayWhileLoading(jsonList = []) {
                if (this.editMode) {
                    return;
                }
                // 边加载边显示
                if (jsonList.length) {
                    for (let i = 0, length = jsonList.length; i < length; i++) {
                        // // 已经存在跳过
                        // let index = this.xitoList.findIndex(v => v.type == jsonList[i].edd);
                        // if (index > -1) {
                        //     continue;
                        // }
                        // if (jsonList[i].su && jsonList[i].su.length) {
                        //     let loaded = jsonList[i].su.every(v => v._object_data);
                        //     // 数据已加载完直接加入页面中显示
                        //     if (loaded) {
                        //         let result = phamulaHandler(jsonList[i], i);
                        //         this.xitoList.push(result);
                        //     }
                        // }
                        
                        // 已经存在跳过
                        if (this.xitoList[i]) {
                            continue;
                        }
                        if (jsonList[i].su && jsonList[i].su.length) {
                            let loaded = jsonList[i].su.every(v => v._object_data);
                            // 数据已加载完直接加入页面中显示
                            if (loaded) {
                                let result = phamulaHandler(jsonList[i], i);
                                this.xitoList.push(result);
                            }
                            break;
                        }
                    }
                }
                if (this.xitoList.length) {
                    this.$loading('', false);
                }
            }
		},
        filters: {
            setModuleClass(type = '') {
                // 如果是弹窗
                if (['typeJ', 'typeQ', 'typeTalk'].indexOf(type) > -1) {
                    return '';
                }
                return 'scroll-reveal';
            }
        },
		computed: {
            api() {
                // return 'http://192.168.0.101:23334';
                return 'http://rtservice.xitohere.com';
                return 'https://rtservice.xitohere.com';
                return process.env.NODE_ENV === 'development' ? 'http://192.168.0.106:23334' : 'http://rtservice.xitohere.com';
            },
			isIframe() {
				return 'iframe' in this.$route.query;
			},
            componentConfig() {
            	const config = {};
            	Object.keys(component).forEach(componentName => {
            		let key = componentName.replace(/\-/g, '');
            		let value = component[componentName];
            		config[key] = value;
            	});
            	return config;
            }
        },
		beforeDestroy() {
            this.closeScrollSocket();
        }
	}
</script>

<style scoped lang="less">
	.home{
        .home-content{
            // position: relative;
        }
        .go-back-top{
        	display: inline-block;
        	position: fixed;
        	z-index: 10;
        	cursor: pointer;
        	overflow: hidden;
        	text-indent: 100%;
        	white-space: nowrap;
        	visibility: hidden;
        	opacity: 0;
        	box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        	transition: opacity .3s 0s, visibility 0s 0s;
        	background: rgba(0, 0, 0, 0.5) url(../../assets/image/cd-top-arrow.svg) no-repeat center 50%;
        }
        .cd-is-visible{
        	visibility: visible;
        	opacity: 1;
        }
        .go-back-top:hover{
            opacity: 1;
        	background-color: #080808;
        }
    }
    @media screen and (max-width: 1024px){
    	.go-back-top{
    		height: 40px;
    		width: 40px;
    		right: 20px;
    		bottom: 20px;
    		background-size: 30px;
    	}
    }
    @media screen and (min-width: 1024px){
    	.go-back-top{
    		height: 50px;
    		width: 50px;
    		right: 30px;
    		bottom: 30px;
    		background-size: 40px;
    	}
    }
</style>
